import { FilterList, FilterListItem, useGetList } from "react-admin";
import { Article as StatusIcon, Category as CategoryIcon } from "@mui/icons-material";
import { StyledListAside } from "@/components/ui/react-admin/StyledListAside";
import { ResourceName } from "@/types";

interface HelpCategory {
  id: string;
  name: string;
  sort_order: number;
}

// Contextual filters for the KB admin grid (Feature 4317 / N3): publication
// status + category, mirroring the Clients list aside. These map to the
// `status` / `category_id` query params the API honors (drafts included via the
// list's permanent include_drafts filter).
export const HelpArticleListAside = () => {
  const { data: categories = [] } = useGetList<HelpCategory>(ResourceName.HELP_CATEGORIES, {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "sort_order", order: "ASC" },
  });

  return (
    <StyledListAside>
      <FilterList label="Status" icon={<StatusIcon />}>
        <FilterListItem label="Published" value={{ status: "published" }} />
        <FilterListItem label="Draft" value={{ status: "draft" }} />
      </FilterList>

      <FilterList label="Category" icon={<CategoryIcon />}>
        {categories.map((c) => (
          <FilterListItem key={c.id} label={c.name} value={{ category_id: c.id }} />
        ))}
      </FilterList>
    </StyledListAside>
  );
};
